<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Account Not Verified.</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Not Verified.</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="about-us-area pt-80">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-10">
                        <div class="about-us-content text-center">
                            <p>Account not verified. Please click on the link sent to your email or click 
                                <span @click="resend" id="resend">here</span> to get another one </p>
                            <h2 class="title">Sorry!</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        name: "NotVerified",
        components: {
            Loading
        },
         data(){
           return{
               fullPage:true,
               isLoading: false,
               email: this.$route.params.email,
           }
        },
        methods:{
            resend() {
                this.isLoading = true;
                this.axios.get('/email/resend/'+this.email).then(() => {
                    this.isLoading = false;
                    this.$swal(
                        'Email sent!',
                        'We have sent a verification link to your email: ' + this.email,
                        'success',
                    )
                    .then(()=> this.$router.push('/login'))
                }).catch(() => {
                    this.isLoading = false;
                    this.$swal(
                        'Something went wrong! Please try again',
                        "warning",
                    )
                })
            },
        },
    }
</script>

<style scoped>
    #resend{
        color: green;
    }
    #resend:hover{
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }
</style>